import * as Yup from "yup";

const SignInValidationScheme = (intl) =>
  Yup.object().shape({
    emailAddress: Yup.string()
      .email(intl.formatMessage({ id: "validation.email.invalid" }))
      .required(intl.formatMessage({ id: "validation.required" })),
    password: Yup.string().required(
      intl.formatMessage({
        id: "validation.password.required",
        defaultMessage: intl.formatMessage({ id: "validation.required" }),
      }),
    ),
  });

export default SignInValidationScheme;
